import map from "lodash/map";
import { CheerzApiPageResponse, CheerzApiTextBlock } from "@Types/api/pagify";
import { NavigationLink, Page, Section, TextBlock, Tile } from "@Types/pagify";

export const convertFromApiToPageContent = (jsonContent: CheerzApiPageResponse): Page => {
  const homePageSections: Section[] = map(jsonContent.page.sections, (section) => {
    return {
      backgroundColor: section.background_color
        ? {
            hex: section.background_color.hex,
            opacityPercentage: section.background_color.opacity_percentage,
          }
        : null,
      cta: map(section.cta, (cta) => {
        return {
          navigationLink: cta.navigation_link,
          text: cta.text,
        };
      }),
      description: section.description && convertFromApiToTextBlockContent(section.description),
      displayType: section.display_type,
      metadata: section.metadata
        ? {
            availability: section.metadata.availability,
            productTag: section.metadata.product_tag,
          }
        : null,
      subtitle: section.subtitle && convertFromApiToTextBlockContent(section.subtitle),
      tileSlugs: section.tile_slugs,
      title: section.title,
    };
  });

  const homePageTiles: Tile[] = map(jsonContent.tiles, (tile) => {
    return {
      backgroundColor: tile.background_color
        ? {
            hex: tile.background_color.hex,
            opacityPercentage: tile.background_color.opacity_percentage,
          }
        : null,
      cta: tile.cta
        ? {
            navigationLink: tile.cta.navigation_link,
            text: tile.cta.text,
          }
        : null,
      images: map(tile.images, (image) => {
        return {
          desktop: {
            "1x": image.desktop["1x"],
            "2x": image.desktop["2x"],
          },
          webMobile: image.web_mobile && {
            "1x": image.web_mobile["1x"],
            "2x": image.web_mobile["2x"],
          },
        };
      }),
      label: tile.label
        ? {
            color: {
              hex: tile.label.color.hex,
              opacityPercentage: tile.label.color.opacity_percentage,
            },
            labelType: tile.label.label_type,
            text: tile.label.text,
          }
        : null,
      metadata: tile.metadata
        ? {
            availability: tile.metadata.availability,
            productTag: tile.metadata.product_tag,
          }
        : null,
      navigationLink: tile.navigation_link,
      slug: tile.slug,
      textBlock1:
        tile.text_block_1 && tile.text_block_1.length > 0
          ? convertFromApiToTextBlockContent(tile.text_block_1)
          : null,
      textBlock2:
        tile.text_block_2 && tile.text_block_2.length > 0
          ? convertFromApiToTextBlockContent(tile.text_block_2)
          : null,
      textBlock3:
        tile.text_block_3 && tile.text_block_3.length > 0
          ? convertFromApiToTextBlockContent(tile.text_block_3)
          : null,
      textBlock4:
        tile.text_block_4 && tile.text_block_4.length > 0
          ? convertFromApiToTextBlockContent(tile.text_block_4)
          : null,
    };
  });

  const homePage = {
    header: {
      text: jsonContent.page.header.text,
      displayType: jsonContent.page.header.display_type,
    },
    metadata: jsonContent.page.metadata
      ? {
          productTag: jsonContent.page.metadata.product_tag,
        }
      : null,
    sections: homePageSections,
    slug: jsonContent.page.slug,
    tiles: homePageTiles,
  };

  return homePage;
};

const convertFromApiToTextBlockContent = (jsonContent: CheerzApiTextBlock[]): TextBlock[] => {
  return map(jsonContent, (textBlock) => {
    return {
      navigationLink: textBlock.navigation_link ? textBlock.navigation_link : null,
      style: textBlock.style,
      text: textBlock.text,
    };
  });
};

export const getLink = (
  navigationLink: NavigationLink | null,
  localeSlug: string
): string | undefined => {
  if (!navigationLink || !navigationLink?.link) {
    return undefined;
  } else if (navigationLink.type === "url") {
    return navigationLink.link;
  } else {
    return `${localeSlug}/${navigationLink?.link}`;
  }
};
